var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210px",
    height: "210px",
    viewBox: "0 0 210 210",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-is-blocked,-deleted-/-Group-/-Products",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MarketPlace-bloked,-deleted-/-1",
    transform: "translate(-1060.000000, -80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(115.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(945.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#808080",
    x: 0,
    y: 0,
    width: 210,
    height: 210,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5,63.5 L43.5,181 C43.5,181.828427 44.1715729,182.5 45,182.5 L170,182.5 C170.828427,182.5 171.5,181.828427 171.5,181 L171.5,63.5 L43.5,63.5 Z",
    id: "Rectangle-2",
    stroke: "#808080",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "#808080",
    fill: "#D8D8D8",
    x: 20.5,
    y: 28.5,
    width: 170,
    height: 37,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#808080",
    x: 85,
    y: 83,
    width: 45,
    height: 7,
    rx: 2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductUnavailable);
export default __webpack_public_path__ + "static/media/product_unavailable.fbc9a12942f2e28709789a4c294b4d6c.svg";
export { ForwardRef as ReactComponent };